import { useEffect, useState } from 'react';
import { useOperator } from '../../contexts/OperatorContext';
import { SupportTicketCategory } from '../../types/commonTypes';
import { mapCategories } from './supportTicketModel';
import { useFetch } from '../useFetch';
import { useUser } from '../../contexts/UserContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useSupportTicketCategories = (getCategories?: boolean) => {
  const [categories, setCategories] = useState<SupportTicketCategory[]>([]);
  const { loading, makeRequest, response, isSuccess } = useFetch();
  const user = useUser();
  const operator = useOperator();

  const canReadCategories =
    (operator.type === 'Hospitality' &&
      (user.permissions.canHosSupportCreate ||
        user.permissions.canHosSupportView)) ||
    (operator.type === 'Residential' &&
      (user.permissions.canResSupportCreate ||
        user.permissions.canResSupportView));

  useEffect(() => {
    setCategories([]);
    if (getCategories && canReadCategories) {
      makeRequest(
        `${BASE_URL_MAP[operator.type]}/SupportTicket/Categories`,
        'get'
      );
    }
  }, [getCategories, operator.type, canReadCategories]);

  useEffect(() => {
    if (!loading && isSuccess) setCategories(mapCategories(response));
  }, [loading, response, isSuccess]);

  return categories;
};
